import { render, staticRenderFns } from "./radish-list-simple.vue?vue&type=template&id=723e75f8"
import script from "./radish-list-simple.vue?vue&type=script&lang=js"
export * from "./radish-list-simple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports